module.exports = __webpack_public_path__ + "img/reddit.342a12c2.svg";